var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { SalesReportsExternalEndpointsService } from '@square/dashboard-protos/models/squareup/salesreporter/service';
import { DataSource, MetricName, TimelinePeriod } from '@square/dashboard-protos/models/squareup/salesreporter/report';
import rpc from '@banking/api/utils/rpc';
const SALES_LOOKBACK_DAYS = 90;
let SalesReporterApi = (_dec = computed('capitalEngineContext.headers'), _class = class SalesReporterApi extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "userInfo", _descriptor2, this);
    _initializerDefineProperty(this, "sentry", _descriptor3, this);
    _initializerDefineProperty(this, "estimatedDailySalesCents", _descriptor4, this);
  }
  get client() {
    return SalesReportsExternalEndpointsService.create(rpc((method, url) => {
      switch (method) {
        case SalesReportsExternalEndpointsService.methods.SalesSummaryReport:
          return '/api/v1/sales-reporter/sales-summary-report';
        default:
          return url;
      }
    }, new Map(Object.entries(this.capitalEngineContext.headers))));
  }
  async getEstimatedDailySalesAmountCents() {
    const now = new Date();
    const startDate = new Date(now);
    startDate.setDate(startDate.getDate() - SALES_LOOKBACK_DAYS);
    const locationIds = this.userInfo.authorizedUnitTokens;
    const response = await this.client.salesSummaryReport({
      merchantToken: this.userInfo.merchantToken,
      locationIds,
      reportingPeriod: {
        inclusiveStart: {
          instantUsec: startDate.getTime() * 1000
        },
        exclusiveEnd: {
          instantUsec: now.getTime() * 1000
        }
      },
      timeZone: {
        tzName: Intl.DateTimeFormat().resolvedOptions().timeZone
      },
      timelinePeriod: TimelinePeriod.NONE,
      selectedMetrics: [MetricName.GROSS_SALES_SUM],
      dataSource: DataSource.SALES_GRAPH
    });
    const grossSalesCents = response.reportData?.[0]?.metrics?.grossSalesSum?.amount;
    if (!grossSalesCents) {
      return undefined;
    }
    return Math.round(grossSalesCents / SALES_LOOKBACK_DAYS);
  }
  async fetchAndStoreEstimatedDailySales() {
    try {
      this.estimatedDailySalesCents = await this.getEstimatedDailySalesAmountCents();
    } catch (e) {
      this.estimatedDailySalesCents = undefined;
      this.sentry.captureException(e);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "estimatedDailySalesCents", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "client", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _class);
export { SalesReporterApi as default };